/**
 * app-search — types + validator for the global search state of the `_app` layout.
 *
 * It centralizes overlays mounted at `_app` level in the URL, so pasting
 * the URL in another browser reopens exactly the same screen/dialog.
 *
 * Pattern: `validateSearch` omits defaults (so it does not pollute the URL in the
 * empty state) and `AppLayoutContent` reflects URL→signals + navigates with
 * `{ replace: true }` when opening/closing (idempotent, survives back/forward and
 * a pasted URL).
 *
 * F0b+: Agape domain dialogs register their keys here.
 */

/** Modal with no entity (shortcut reference). */
export type AppModalKind = "shortcuts";

export interface AppLayoutSearch {
  /** Open modal with no entity. */
  modal?: AppModalKind;

  // ── Account switch (multi-account #18) ─────────────────────────────────────
  /** Account switcher open (`?account=switch`).*/
  account?: "switch";
}

/**
 * Validates + normalizes the layout search. Omits defaults to keep the URL
 * clean. Tolerant: unknown values are discarded (does not break rendering).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};

  // ── Modal with no entity ──
  if (search.modal === "shortcuts") {
    out.modal = "shortcuts";
  }

  // ── Account switcher (multi-account) ──
  if (search.account === "switch") {
    out.account = "switch";
  }

  return out;
}
